import styled from 'styled-components';
import { MaxWidth } from '../../base';
import getReadibilityColor from '../../utils/styles/utils/readibility';

const FooterWrapper = styled.div`
  background-color: ${({ theme: { colors } }) => colors.primary.secondary};
  color: ${({ theme }) => getReadibilityColor(theme.colors.primary.secondary, theme)};
  padding: 100px 0;
  font-size: 14px;
  ${MaxWidth.sm`
    padding: 60px 0;
  `}
`;

const FooterSocial = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    display: inline-block;
    margin-right: 30px;
  }
`;

const FooterResourceList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  li {
    padding: 15px 0;
    a {
      color: ${({ theme }) => getReadibilityColor(theme.colors.primary.secondary, theme)};
    }
  }
`;

const FooterAddressList = styled.div`
  position: relative;
  margin-top: 32px;
`;

const FooterAddressListIcon = styled.div`
  position: absolute;
  left: 0;
  top: 0;
`;

const FooterAddressListDesc = styled.div`
  padding-left: 32px;
`;

const FooterBottom = styled.div`
  padding: 30px 0;
  background-color: ${({ theme: { colors } }) => colors.dark.primary};
  color: ${({ theme: { colors } }) => colors.light.primary};
`;

const FooterBottomFlex = styled.div`
  display: flex;
  justify-content: space-between;
  opacity: 0.4;
  font-size: 14px;
  a {
    padding: 0 16px;
    color: ${({ theme: { colors } }) => colors.light.primary};
    &:hover {
      color: ${({ theme: { colors } }) => colors.light.primary};
    }
  }
  ${MaxWidth.sm`
    display: block;
    text-align: center;
    a {
      margin-top: 16px;
    }
  `}
`;

export {
  FooterWrapper,
  FooterBottom,
  FooterBottomFlex,
  FooterSocial,
  FooterResourceList,
  FooterAddressList,
  FooterAddressListIcon,
  FooterAddressListDesc
};
